import { render, staticRenderFns } from "./SubscribeToPremiumModal.vue?vue&type=template&id=2c6a3e8a"
import script from "./SubscribeToPremiumModal.vue?vue&type=script&lang=js"
export * from "./SubscribeToPremiumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports